import { DynamicLayoutSettings } from '../models/dynamic-layout-settings';

export class DelegatePersistLayoutParams {
  innerLayout?: DynamicLayoutSettings;

  constructor(init: Partial<DelegatePersistLayoutParams>) {
    Object.assign(this, init);
  }
}
